import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LogoAndText from "@/components/LogoAndText";
import {
  callWithAuth,
  sessionStatus,
  SessionStatusRequest,
  SessionStatusResponse,
} from "@/api/Api";
import { Button } from "@/components/Buttons/Button";
import { useQueryClient } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
const CheckoutComplete: React.FC = () => {
  const location = useLocation();
  const { "*": backUrl } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const once = useRef(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const sessionId = queryParams.get("session_id");

  const [checkoutTitle, setCheckoutTitle] = useState("Payment successful");
  const [checkoutMessage, setCheckoutMessage] = useState(
    "Your payment was successful."
  );
  const posthog = usePostHog();

  useEffect(() => {
    if (sessionId && !once.current) {
      once.current = true;
      const data: SessionStatusRequest = {
        sessionId: sessionId ?? "",
        sku: queryParams.get("sku") ?? "",
      };
      callWithAuth(sessionStatus, data)
        .then((res: SessionStatusResponse) => {
          if (res.sessionStatus == "open") {
            navigate(`/checkout`);
            // Remount embedded Checkout
          } else if (res.sessionStatus == "complete") {
            switch (res.paymentStatus) {
              case "succeeded":
                setCheckoutTitle("Payment successful");
                setCheckoutMessage("Your payment was successful.");
                break;
              case "canceled":
                setCheckoutTitle("Payment canceled");
                setCheckoutMessage(
                  "Your payment was canceled. Please try again."
                );
                break;
              case "processing":
                setCheckoutTitle("Processing payment...");
                setCheckoutMessage(
                  "It could take up to 10 minutes to process your payment."
                );
                break;
              case "requires_payment_method":
                setCheckoutTitle("Payment required");
                setCheckoutMessage("Please try again.");
                break;
              case "requires_action":
                setCheckoutTitle("Payment action required");
                setCheckoutMessage(
                  "Please try again, and if the problem persists, contact support@fluentwithparrot.com"
                );
                break;
            }
            // Optionally use session.payment_status or session.customer_email
            // to customize the success page
          }
          queryClient.invalidateQueries();
        })
        .catch((err) => {
          console.log(err.message);
          queryClient.invalidateQueries();
        });
    }
  }, []);

  return (
    <div className="w-full h-full appPadding flex flex-col items-center justify-center">
      <LogoAndText />
      <div className="mt-8 text-center rounded-md p-4">
        <h1 className="text-xxl text-center font-bold mb-4">{checkoutTitle}</h1>
        <p className="mb-2">{checkoutMessage}</p>
        <div className="mt-6 p-4 rounded-md">
          <Button
            className="bg-[var(--color-orange)] hover:bg-[var(--color-orange)] h-[var(--button-height)]"
            onClick={() => {
              posthog.capture("checkout_complete_success");
              navigate(`/${backUrl}`);
            }}
          >
            Back to Parrot
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutComplete;
